import axios from 'axios';
import React, { useRef, useEffect, useState } from 'react'
import {  FaDownload, FaSearchPlus, FaSearchMinus } from 'react-icons/fa';
import ResumePreview from './ResumePreview';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ResumePreviewLayout = ({ formData }) => {
  const [scale, setScale] = useState(1);
  // const templateComponent = [
  //   <ResumePreview />
  // ]

  const location = useLocation();
  let templateId = location?.state?.id ?? localStorage.getItem("templateId")
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  let formDataLength = Object.keys(formData ?? {}).length;

  if (formDataLength === 0) {
    let formDataFromLocalStorage = localStorage.getItem("formData");
    formData = formDataFromLocalStorage !== null ? JSON.parse(formDataFromLocalStorage) : formData;
    formDataLength = Object.keys(formData ?? {}).length
  }


  const [parentHeight, setParentHeight] = useState('auto');
  const [isLoading, setIsLoading] = useState(false)
  const contentRef = useRef();
  const [pages, setPages] = useState(1);

  let A4_HEIGHT_MM = 297;
  // let A4_HEIGHT_MM = window.innerWidth<768 ? 450 : 297;
  let A4_HEIGHT_PX = (A4_HEIGHT_MM / 25.4) * 96;
  const A4_WIDTH_MM = 200;
  // const A4_WIDTH_MM = window.innerWidth<768 ? 105 : 210;
  const [childContentHeight, setChildContentHeight] = useState(A4_HEIGHT_PX)

  const getScale = (contentRef) => {
    let containerWidth = contentRef.current.offsetWidth;
    const pageWidth = (A4_WIDTH_MM / 25.4) * 96; // Convert mm to pixels
    if (window.innerWidth < 768) {
      containerWidth = window.innerWidth - 30;
    }
    return Math.min(1, containerWidth / pageWidth);
  };

  const getChildContentHeight = (contentRefHeight) => {
    setChildContentHeight(contentRefHeight);
  }



  useEffect(() => {



    const resizeObserver = new ResizeObserver(() => {

      if (contentRef.current) {
        const scaleValue = getScale(contentRef);
        setScale(scaleValue);
      }


    });

    if (contentRef.current) {

      resizeObserver.observe(contentRef.current);
      const borderElement = document.createElement('div');

      if (childContentHeight > (A4_HEIGHT_PX * pages)) {
        setPages(pages + 1);
        contentRef.current.style.height = `${A4_HEIGHT_PX * (pages + 1)}px`

        // contentRef.current.style.border = `2px solid black`;
        contentRef.current.style.position = 'relative';
        borderElement.style.position = 'absolute';
        borderElement.style.top = `${A4_HEIGHT_PX - 30}px`; // Set the position of the border
        borderElement.style.left = '0';
        borderElement.style.right = '0';

        borderElement.style.height = '2px'; // Height of the border
        borderElement.style.backgroundColor = '#e5e7eb'; // Color of the border
        borderElement.style.zIndex = '1'; // Ensure it sits above the content
        // Append the border only if it hasn't been added yet

        if (!contentRef.current.querySelector('.dynamic-border')) {
          borderElement.className = 'dynamic-border';
          contentRef.current.appendChild(borderElement);

        }
      } else if (childContentHeight < (A4_HEIGHT_PX * (pages - 1)) && pages > 1) {
        setPages(pages - 1);
        contentRef.current.style.height = `${A4_HEIGHT_PX * (pages - 1)}px`
        if ((pages - 1) === 1 || (pages === 1)) {
          if (contentRef.current.querySelector('.dynamic-border')) {

            contentRef.current.querySelector('.dynamic-border').remove()
          }
        }

      }
      else {
        contentRef.current.style.height = `${(A4_HEIGHT_PX - 10) * (pages)}px`
        const scaleValue = getScale(contentRef);
        setParentHeight(((A4_HEIGHT_PX - 10) * (pages) + 50) * scaleValue)

      }




    }




    return () => resizeObserver.disconnect();
    // eslint-disable-next-line
  }, [childContentHeight]);





  const downloadAsPDF = async (firstName) => {
    if (formDataLength === 0) {
      toast("Please Fill Form to download your resume");
      return;
    }

    if (isAuthenticated) {
      const baseUrl = process.env.REACT_APP_BASE_URL

      try {
        setIsLoading(true)
        const response = await axios.post(`${baseUrl}/pdf`, { formData: formData, id: templateId }, {
          responseType: 'blob'  // Set response type to blob for downloading the PDF
        });

        // Create a URL to download the PDF
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);

        // Create a link to download the PDF
        const link = document.createElement('a');
        link.href = url;
        let fileName = firstName + '-resume.pdf'
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        setIsLoading(false)
      } catch (error) {
        console.error('Error generating PDF:', error);
      }
    } else {
      navigate("/signin", {
        state: {
          fromPreviewLayout: true
        }
      })
    }


  }

  const handleZoomIn = () => {
    setScale(prevScale => Math.min(prevScale + 0.1, 1.5));
  };

  const handleZoomOut = () => {
    setScale(prevScale => Math.max(prevScale - 0.1, 0.5));
  };





  return (


    <div className="sticky top-0 md:flex h-screen ">
      <div className="flex flex-col bg-gray-100">
        {/* Resume Preview Navbar */}
        <div className="bg-stone-400 shadow-md p-4 flex justify-between items-center">
          <h2 className="text-xl font-semibold">Resume Preview</h2>
          <div className="flex space-x-2">
            <button onClick={() => downloadAsPDF(formData?.firstName)} className="p-2 bg-blue-500 text-white rounded hover:bg-blue-600">
              {isLoading ? <div role="status">
                <svg aria-hidden="true" class="w-4 h-4 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                  <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                </svg>
                <span class="sr-only">Loading...</span>
              </div> : <FaDownload />}
            </button>
            {/* <button onClick={handleShare} className="p-2 bg-green-500 text-white rounded hover:bg-green-600">
              <FaShare />
            </button> */}
            <button onClick={handleZoomIn} className="p-2 bg-gray-300 rounded hover:bg-gray-400">
              <FaSearchPlus />
            </button>
            <button onClick={handleZoomOut} className="p-2 bg-gray-300 rounded hover:bg-gray-400">
              <FaSearchMinus />
            </button>
          </div>
        </div>
        {formDataLength === 0 && <div className='text-center text-[10px] md:text-sm pt-2 text-muted-foreground font-semibold'>(Note: This is just a preview please fill form to download your resume)</div>}

        <div className="p-4 overflow-y-hidden overflow-x-auto md:overflow-auto" style={{
          height: parentHeight, // Dynamically adjust parent height
        }}>

          <div
            id='previewLayout'
            ref={contentRef}
            className="border rounded-lg overflow-hidden bg-white shadow-lg mx-auto"
            style={{
              width: `${A4_WIDTH_MM}mm `,
              transform: `scale(${scale})`,
              transformOrigin: window.innerWidth < 768 ? 'top left' : 'top center',
            }}
          >

            <ResumePreview templateId={templateId} getChildContentHeight={(contentRefHeight) => getChildContentHeight(contentRefHeight)} />
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default ResumePreviewLayout;